import './App.css';
import Boton from './componentes/Boton';
import Contador from './componentes/contador';
import { useState } from 'react';

function App() {

  const [numClics, setNumClics] = useState(0)

  const manejarClic = () => {
    setNumClics(numClics + 1);
  }

  const reiniciarContador = () => {
    setNumClics(0);
  }

  return (
    <div className='App'>
      <div className='titulo-contenedor'>
        <p> CONTADOR DE CLICS </p>
      </div>
      <div className='contenedor-principal'>
        <Contador numClics={numClics} />
        <Boton
          texto= 'Clic'
          esBotonDeClic={true}
          manejarClic={manejarClic} />
        <Boton
          texto= 'Reiniciar'
          esBotonDeClic={true}
          manejarClic={reiniciarContador} />    
      </div>
    </div>
  );
}

export default App;
